/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLeaf = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8.63 7.381c4.876-4.37 9.002-5.704 11.965-5.318.159.021.278.044.357.064l.579.146.161.645.016.082.032.208c.395 3.031-1.01 7.277-5.62 12.3a12.064 12.064 0 0 1-2.497 2.075l-.461.282a16.778 16.778 0 0 1-8.522 2.294l.422-.004-1.648 1.648L2 20.39l1.647-1.647a16.786 16.786 0 0 1 2.535-8.5l.028-.046a12.142 12.142 0 0 1 2.086-2.513zm1.461 7.745L7.289 17.93c1.693-.3 3.32-.892 4.788-1.745l.367-.22.276-.181zM19.793 4.01l-.244.002c-.704.022-1.576.171-2.603.51-2.216.734-4.662 2.215-7.298 4.635a10.117 10.117 0 0 0-1.732 2.083l-.272.448a14.74 14.74 0 0 0-1.77 4.829L15 7.389l1.414 1.414-4.675 4.675 2.869.717.038-.04c2.305-2.51 3.759-4.849 4.525-6.98l.11-.318c.377-1.14.52-2.09.513-2.831z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLeaf as Leaf };
